import Loadable from '@townsquare/loadable';

export const SearchRedirectAction = Loadable({
	loader: () => import(/* webpackChunkName: "SearchRedirectAction" */ './SearchRedirectAction'),
	loading: () => null,
});
